<template>
  <div
    class="checkbox"
    :class="[ disabled ? 'disabled' : '',]"
    @mousedown.stop="change"
    @click="click"
  >
    <label>
      <i :class='[ "icon", getIcon, disabled ? "disabled" : "",]'></i>
      <input
        type="checkbox"
        :checked="value"
        class="checkbox-input"
        :disabled="disabled"
      >
    </label>
    <div v-if='!noTip' :class='[ "tip", disabled ? "disabled" : "",]'>
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  name: 'Checkbox',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noTip: {
      type: Boolean,
      default: false,
    },
    stop: {
      type: Boolean,
      default: false,
    },
    miss: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getIcon() {
      if (!this.miss) {
        return this.value ? 'fi-checkbox-on' : 'fi-checkbox-off';
      }
      return 'fi-checkbox-min';
    },
  },
  methods: {
    change(e) {
      if (this.stop) {
        e.stopPropagation();
      }
      this.$emit('toggle:value', this.miss ? false : !this.value);
    },
    click(e) {
      if (this.stop) {
        e.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .checkbox-input {
    display: none;
  }
  .checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .icon {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .tip {
    margin-left: 10px;
  }
  .disabled {
    cursor: not-allowed !important;
    opacity: 0.5;
  }
  .fi-checkbox-on {
    color:#3dd196;
  }
  .fi-checkbox-off {
    color: #bfc8e1;
  }
  .fi-checkbox-min {
    color: $blue;
  }
</style>
